import { Plugins } from '@leverege/plugin';
function nameTypeKey(name, objectType) {
  return `${name}:${objectType}`;
}
function addToType(typeMap, type, field) {
  const arr = typeMap.get(type);
  if (arr == null) {
    typeMap.set(type, [field]);
  } else {
    arr.push(field);
  }
}
function addToLookup(lookup, type, field) {
  const key = nameTypeKey(field.attrName, type);
  const tArr = lookup.get(key);
  if (tArr == null) {
    lookup.set(key, field);
  }
}
function addExportFields(typeMap, lookup, fields) {
  for (let i = 0; i < fields.length; i++) {
    const field = fields[i];
    const {
      objectType
    } = field;
    if (Array.isArray(objectType)) {
      objectType.forEach(type => {
        addToType(typeMap, type, field);
        addToLookup(lookup, type, field);
      });
    } else {
      addToType(typeMap, objectType, field);
      addToLookup(lookup, objectType, field);
    }
  }
}
function processor(fields) {
  const types = new Map();
  const lookup = new Map();
  addExportFields(types, lookup, fields);
  const creators = Plugins.get('ExportFieldCreator');
  creators.forEach(creator => {
    const fields = creator.create();
    addExportFields(types, lookup, fields);
  });
  return {
    types,
    lookup
  };
}
const view = Plugins.createView('ExportField', {
  processor
});
function getExportFieldsFor(type) {
  const {
    types
  } = view.get();
  return types.get(type) || [];
}
function getExportField(attrName, objectType) {
  const key = nameTypeKey(attrName, objectType);
  const {
    lookup
  } = view.get();
  return lookup.get(key) || null;
}
const dirty = () => {
  view.dirty = true;
};
Plugins.get('ExportFieldCreator').forEach(dc => {
  dc.onChange(dirty);
});
Plugins.on('ExportFieldCreator', evt => {
  const add = evt.type === Plugins.PLUGIN_ADDED;
  evt.plugin.onChange(add ? dirty : null);
});
export default {
  getExportFieldsFor,
  getExportField
};